import { render, staticRenderFns } from "./RulerLabel.vue?vue&type=template&id=2f69ab69&scoped=true"
import script from "./RulerLabel.vue?vue&type=script&lang=js"
export * from "./RulerLabel.vue?vue&type=script&lang=js"
import style0 from "./RulerLabel.vue?vue&type=style&index=0&id=2f69ab69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69ab69",
  null
  
)

export default component.exports